<ng-container>
  <div class='blog-item rounded bg-white shadow-dark wow fadeIn'>
    <div class='thumb'>
    </div>
    <div class='details row'>
      <div class='col-lg-9'>
        <h4 class='my-0 title'><a href='javascript:'>
          {{ webinar.fields.title }}</a></h4>
        <ul class='list-inline meta mb-0 mt-2'>
          <li class='list-inline-item'>{{ webinar.fields.price | uppercase }}</li>
          <li class='list-inline-item'>{{ webinar.fields.date | uppercase | date: 'MMMM d, y h:mm a' }}</li>
          <li class='list-inline-item'>{{ webinar.fields.location | uppercase }}</li>
          <li class='list-inline-item'>{{ 'sections.webinars.lang' | translate }}: {{ webinar.fields.language | lowercase }}</li>
        </ul>
      </div>
      <div class='col-lg-3 d-flex align-items-center justify-content-end'>
        <kdn-button
          (kdmClick)='exampleModalCenter.show()'
          [label]="'buttons.readMore' | translate">
        </kdn-button>
      </div>
    </div>
  </div>
</ng-container>

<app-ui-modal #exampleModalCenter dialogClass="modal-dialog-centered work-modal" [hideHeader]="true" [hideFooter]="true">
  <div class="app-modal-body">
    <div id="small-dialog1" class="white-popup zoom-anim-dialog mfp-hide">
      <h2 class='text-center'>
        <img id='modal-logo' [src]="'assets/images/logo/kdn_logo_only_white_bg.png'"  alt="webinar-title" />
        {{ webinar.fields.title }}
      </h2>
      <div class="spacer-20"></div>
      <p>
        {{ webinar.fields.description }}
      </p>
      <ul class='meta mb-0 mt-2'>
        <li>{{'sections.webinars.tutor' | translate | titlecase }}: {{ webinar.fields.tutor }}</li>
        <li>{{'sections.webinars.price' | translate | titlecase }}: {{ webinar.fields.price | uppercase }}</li>
        <li>{{'sections.webinars.when' | translate | titlecase }}: {{ webinar.fields.date | uppercase | date: 'MMMM d, y h:mm a' }}</li>
        <li>{{'sections.webinars.where' | translate | titlecase }}: {{ webinar.fields.location | uppercase }}</li>
        <li>{{ 'sections.webinars.lang' | translate | titlecase }}: {{ webinar.fields.language | lowercase }}</li>
      </ul>
      <div class="spacer-20"></div>
      <div class='text-right'>
        <kdn-button
          (kdmClick)='showRegistrationPage(webinar.fields.registerLink)'
          [label]="'buttons.register' | translate | titlecase">
        </kdn-button>
      </div>
    </div>
  </div>
</app-ui-modal>
